import { render, staticRenderFns } from "./ImageViewRound.vue?vue&type=template&id=20d4c8da&scoped=true"
import script from "./ImageViewRound.vue?vue&type=script&lang=ts"
export * from "./ImageViewRound.vue?vue&type=script&lang=ts"
import style0 from "./ImageViewRound.vue?vue&type=style&index=0&id=20d4c8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4c8da",
  null
  
)

export default component.exports